import styles from './SelectItem.module.css';

const SelectItem: React.FC<{
    error?: boolean;
    labelled?: boolean;
    defaultChecked?: boolean;
    checked?: boolean;
    className?: string;
    type: string;
    name?: string;
    value: string;
    label?: React.ReactNode;
    onChange?: (value: string, checked: boolean) => void;
    disabled?: boolean;
}> = ({
    error,
    labelled = true,
    className,
    type,
    defaultChecked,
    checked,
    name,
    value,
    label,
    onChange,
    disabled,
}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (onChange && !disabled) {
            onChange(value, e.target.checked);
        }
    };

    const inputProps = checked !== undefined ? { checked } : { defaultChecked };

    return (
        <label
            className={`${className ? className : ''} ${styles.wrapper} ${
                labelled ? 'labelled' : ''
            } ${error ? styles.error : ''} ${disabled ? styles.disabled : ''}`}
        >
            <input
                disabled={disabled}
                {...inputProps}
                onChange={handleChange}
                value={value}
                type={type}
                name={name}
            />
            {labelled && <span className={styles.label}>{label || value}</span>}
            {!labelled && <span></span>}
        </label>
    );
};

export default SelectItem;
